import { render, staticRenderFns } from "./SubmitRow.vue?vue&type=template&id=9cf48f36&scoped=true&"
import script from "./SubmitRow.vue?vue&type=script&lang=js&"
export * from "./SubmitRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf48f36",
  null
  
)

export default component.exports